class Anchor {
    constructor() {
        this.header = document.getElementById("ftsHeader");
        if(this.header) {
            this.events();
        }
    }

    // ============
    // Events
    // =============
    events() {
        document.addEventListener('click', event => this.checkClickTarget(event));
        window.addEventListener("load", this.checkUrl.bind(this)); 
    }

    // ============
    // Methods
    // =============
    
    //クリックの要素はアンカーリンクかどうかをチェック 
    checkClickTarget(event) {
        if(event.target.closest('a')) {
            const hash = event.target.closest('a').hash || false;
            if(hash) {
                event.preventDefault();
                const element = document.querySelector(hash);

                this.updateUrl(hash);
                this.fixScroll(element);
            }

        }

    }

    // ページの読み込みの際のURLにハッシュが付いていないかをチェック
    checkUrl() {
        if(window.location.hash) {
            const element = document.querySelector(window.location.hash);
            this.fixScroll(element);
        }
    }

    // アンカーリンクのクリックの際
    // ページのURLにハッシュを追加
    updateUrl(hash) {
        if(!window.location.hash) {
            window.location.href = window.location.href.concat(hash);
        }else {
            if(window.location.hash != hash) {
                window.location.href = window.location.href.replace(window.location.hash, hash);
            }
        }
    }

    // スクロールの位置を修正
    fixScroll(element) {
        if(element) {
            const elementScrollPosition = element.getBoundingClientRect().y;
    
            window.scrollBy(0, elementScrollPosition - this.header.clientHeight);
        }

    }
    
}

export default Anchor;